import styled from "styled-components";

type GnbSectionTypes = {
  slug?: string;
};

export const GnbSection = styled.div<GnbSectionTypes>`
  nav > ul {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: ${(props) => props.theme.colors.b.wh};
    position: relative;
    z-index: 10;

    > li {
      font-size: 1rem;
      line-height: 1.5;
      > a {
        color: ${(props) => props.theme.colors.b.g};
        font-weight: bold;
        display: inline-block;
        padding: 25px 22px;

        > span {
          display: inline-block;
          padding: 1px 0;
          border-bottom: 2px solid ${(props) => props.theme.colors.b.wh};
          transition: all 0.3s ease-in-out;
          text-transform: capitalize;
        }

        &:hover {
          color: ${(props) => props.theme.colors.b.dgr};
          > span {
            border-bottom: 2px solid ${(props) => props.theme.colors.b.dgr};
          }
        }
      }
    }
  }

  @media (max-width: ${(props) => props.theme.breakpoints.sm}) {
    position: fixed;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    overflow-y: auto;
    background: ${(props) => props.theme.colors.b.dgr};

    nav {
      padding: 20px 0;
    }

    nav > ul {
      background: ${(props) => props.theme.colors.b.dgr};
      display: block;
      padding: 0 4%;
      > li {
        > a {
          display: block;
          color: ${(props) => props.theme.colors.b.wh};
          border-bottom: 1px solid ${(props) => props.theme.colors.b.wh};
          padding: 11px 0;
          font-size: 1.5rem;
          > span {
            border-bottom: 0;
          }
        }
        > ul {
          padding: 8px 0;
          border-bottom: 1px solid ${(props) => props.theme.colors.b.wh};
          > li {
            > a {
              color: ${(props) => props.theme.colors.b.wh};
              display: block;
              font-size: 1.25rem;
              padding: 6px 4px;
            }
          }
        }
      }
    }
  }
`;

type SubMenuTypes = {
  hovered?: boolean;
};

export const SubMenu = styled.div<SubMenuTypes>`
  position: fixed;
  background: ${(props) => props.theme.colors.b.wh};
  top: ${(props) => (props.hovered ? "80px" : "-100%")};
  left: 0;
  z-index: 1;
  opacity: ${(props) => (props.hovered ? "1" : "0")};
  width: 100%;
  transition: all 0.3s ease-in-out;
  border-bottom: 1px dotted ${(props) => props.theme.colors.b.lg};

  > ul {
    width: 100%;
    max-width: ${(props) => props.theme.layout.maxWidth};
    margin: 0 auto;
    padding: 30px 0;
    border-top: 1px dotted ${(props) => props.theme.colors.b.lg};
    > li {
      line-height: 1.5;
      display: inline-block;
      > a {
        font-size: 1rem;
        padding: 10px 16px;
        color: ${(props) => props.theme.colors.b.bk};
        border-radius: 100px;
        margin: 0 8px;
        &:hover {
          background-color: ${(props) => props.theme.colors.b.dgr};
          color: ${(props) => props.theme.colors.b.wh};
        }
      }
    }
  }
`;

export const FootNavSection = styled.div`
  nav > ul {
    display: flex;
    justify-content: space-between;
    align-items: center;
    > li {
      font-size: 1rem;
      line-height: 1.5;
      a {
        color: ${(props) => props.theme.colors.b.wh};
        display: inline-block;
        padding: 4px 12px;
      }
    }
  }

  @media (max-width: ${(props) => props.theme.breakpoints.sm}) {
    nav {
      padding: 0 0 16px 0;
      margin-left: -10px;
    }
  }
`;

export const SnsNavSection = styled.div`
  nav > ul {
    display: flex;
    justify-content: space-between;
    align-items: center;
    > li {
      a {
        display: inline-block;
        padding: 0 6px;
      }
    }
  }

  @media (max-width: ${(props) => props.theme.breakpoints.sm}) {
    nav {
      padding: 16px 0 0 0;
      margin-left: -10px;
    }
  }
`;
